<script>
import moment from "moment";
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import { changeLeadStage } from '@/utils/lead';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ReminderForm from '@/components/common/reminder-form.vue';

export default {
 components: {
  ReminderForm
 }, 
inject: ['setLoading'],    
 data() {
  return {
   editor: ClassicEditor,
   editorConfig: {},
   errors: {}, 
   id: null,
   lead_id: '',
   title: '',
   status: '',
   from_date: '',
   to_date: '',
   description: '',
   reminder_type: '',
   reminder_datetime: '',
   advance_notification: '',
   created_at: '',
   is_notified: 0,
   is_completed: 0,
   types: ['FollowUp','Meeting','Call','Email','Other'],
   reminderData: {},
   isEditing: false,
   reminders: [],
   pagination: {
    current_page: 1,
    per_page: 25,
    last_page: 1,
    total: 0,
    links: []
   },
   pending_stage_id: null,
   pending_is_upload_document: false,
  };
 },

 computed: {
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page;
  },
 },

 mounted(){
  const start = moment().subtract(0, "days");
  const end = moment();

   new DateRangePicker(
    this.$refs.dateRangeInput,
     {
      startDate: start,
      endDate: end,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - "
      },
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      }
     },
     (start, end) => {
      this.setDateRange(start, end);
     },
     this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);
 },

 methods: {
  
  booking_range(start, end) {
   return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
  },

  setDateRange(start, end) {
   this.from_date = start.format("YYYY-MM-DD");
   this.to_date = end.format("YYYY-MM-DD");
  },

  addReminder(lead_id){
   this.resetForm(); 
   this.lead_id = lead_id;
   this.isEditing = false;
   this.reminderData = {};
  },

  editReminder(row){
   this.id = row.id;
   this.lead_id = row.lead_id;
   this.title = row.title;
   this.description = row.description || '';
   this.reminder_type = row.reminder_type;
   this.reminder_datetime = this.$formatDate(row.reminder_datetime, 'YYYY-MM-DD HH:mm:ss')
   this.advance_notification = row.advance_notification;
   this.created_at = row.created_at;
   this.is_notified = row.is_notified;
   this.is_completed = row.is_completed;
   this.isEditing = true;
   // Prepare data to pass to ReminderForm component
    this.reminderData = {
     id: row.id,
     title: row.title,
     description: row.description || '',
     reminder_type: row.reminder_type,
     reminder_datetime: this.$formatDate(row.reminder_datetime, 'YYYY-MM-DD[T]HH:mm'),
     advance_notification: row.advance_notification
    };
  },

  addReminderWithStage(lead_id, stage_id, is_upload_document = false) {
    this.resetForm(); 
    this.lead_id = lead_id;
    this.pending_stage_id = stage_id;  
    this.pending_is_upload_document = is_upload_document;  
    this.isEditing = false;
    this.$nextTick(() => {
      const modalEl = document.getElementById('reminder_modal');
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      modal.show();
    });
},
async submitForm(){
    this.errors = {};
      console.log('pending_stage_id:', this.pending_stage_id);
    console.log('pending_is_upload_document:', this.pending_is_upload_document);
    this.setLoading(true);
    try{
     const reminderSuccess = await this.$refs.reminderForm.submitReminder(); 
     if(reminderSuccess){
      if(this.pending_stage_id){
       // Check if document upload is also needed
       if(this.pending_is_upload_document){
        // Don't change stage yet — emit to open document modal
        this.$emit('open-document-modal', this.lead_id, this.pending_stage_id);
        this.$closeModal('reminder_modal');
        this.pending_stage_id = null;
        this.pending_is_upload_document = false;
        const message = this.isEditing ? 'Reminder updated successfully!' : 'Reminder created successfully!';
        this.$swalToast(message);
        this.resetForm();
        return;
       }
       // No document needed — change stage directly
       await changeLeadStage(this.lead_id, this.pending_stage_id);
       this.$swalToast('Stage updated successfully!'); 
       this.pending_stage_id = null;
       this.pending_is_upload_document = false;
      }
       const message = this.isEditing ? 'Reminder updated successfully!' : 'Reminder created successfully!';
       this.$swalToast(message);
       this.$emit('updated'); 
       this.$closeModal('reminder_modal');
       this.resetForm();
     }
    }catch(error){
     if(error.type === 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message || 'An error occurred', 'error'); 
     }
    }finally{
     this.setLoading(false);
    } 
},

   async deleteReminder(){
    this.setLoading(true);
    try{
     const response = await axios.delete(`/reminders/${this.id}/delete`);
     this.$swalToast(response.data.message);
     this.$emit('updated');
     this.$closeModal('reminder_delete_modal');
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false);
    } 
   },

   resetForm(){
    this.id = null;
    this.title = '';
    this.description = '';
    this.reminder_type = '';
    this.reminder_datetime = '';
    this.advance_notification = '';
    this.created_at = '';
    this.is_notified = 0;
    this.is_completed = 0;
    this.reminderData = {};
    this.isEditing = false;
    if(this.$refs.reminderForm){
     this.$refs.reminderForm.resetForm();
    }
    this.pending_is_upload_document = false;
   },

   async all(page = 1){
    this.setLoading(true);
    try{
     const params = {
      page,
      status: this.status,
      from_date: this.from_date,
      to_date: this.to_date,
      per_page: this.pagination.per_page,
     }; 
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/reminders?${query_string}`);
     this.reminders = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.$swalToast(error.message, 'error');
    }finally{
     this.setLoading(false); 
    }
   },

   changePage(url) {
    if (!url) return;
    const page = new URL(url).searchParams.get("page");
    this.all(page);
   },

   clearFilter(){
    this.status = '';
    this.all();
   },

 },

};
</script>

<template>
<!-- Add/Edit -->
<div class="modal fade" id="reminder_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header">
<h4 class="modal-title">{{id === null ? 'Add' : 'Edit'}} Reminder</h4>
<button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
<i class="ti ti-x"></i>
</button>
</div>

<form @submit.prevent="submitForm">
<div class="modal-body">

 <ReminderForm ref="reminderForm" :lead-id="lead_id" :is-editing="isEditing" :initial-data="reminderData" /> 

</div>
<div class="modal-footer">
<button type="button" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</button>
<button type="submit" class="btn btn-primary">Save</button>
</div>
</form>
</div>
</div>
</div>
<!-- /Add/Edit -->

<!-- View Details -->
<div class="modal fade" id="reminder_view_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-header bg-dark">
<h4 class="modal-title text-white">{{title}}</h4>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">
<h5 class="mb-2">Reminder Details</h5>
<div class="border rounded mb-3 p-2">
<div class="row row-gap-3">
 <div class="col-md-4">
 <div class="text-center">
   <span class="d-block mb-1 fw-bold">Created On</span>
   <p class="text-dark">{{$formatDate(created_at, 'DD MMM YYYY')}}</p>
 </div>
 </div>
 <div class="col-md-5">
 <div class="text-center">
    <span class="d-block mb-1 fw-bold">Reminder Date</span>
    <p class="text-dark">{{$formatDate(reminder_datetime, 'DD MMM YYYY, h:mm a')}}</p>
 </div>
 </div>
 <div class="col-md-3">
 <div class="text-center">
 <span class="d-block mb-1 fw-bold">Type</span>
  <span class="badge bg-soft-pink d-inline-flex align-items-center">
  <i class="fas fa-circle fs-6 me-1"></i>{{reminder_type}}</span>
 </div>
 </div>
</div>
</div>

<div class="notice-widget">
        
<div class="d-flex align-items-center justify-content-between mb-4" v-if="is_notified">
 <div class="d-flex overflow-hidden me-2">
 <span class="bg-warning avatar avatar-md me-3 rounded-circle flex-shrink-0"><i class="ti ti-circle-dot fs-16"></i></span>
<div class="overflow-hidden">
 <p class="text-truncate mt-1 fw-bold">Notified</p>
</div>
</div>
</div>

<div class="d-flex align-items-center justify-content-between mb-4" v-if="is_completed">
 <div class="d-flex overflow-hidden me-2">
 <span class="bg-success avatar avatar-md me-3 rounded-circle flex-shrink-0"><i class="ti ti-circle-dot fs-16"></i></span>
<div class="overflow-hidden">
 <p class="text-truncate mt-1 fw-bold">Completed</p>
</div>
</div>
</div>

</div>

 <div class="mb-3">
 <h5 class="mb-2">Description</h5>
 <p v-html="description"></p>
 </div>

</div>
</div>
</div>
</div>
<!-- /View Details -->

<!-- All Reminders -->
<div class="modal fade" id="all_reminder">
<div class="modal-dialog modal-dialog-centered modal-lg">
<div class="modal-content">
<div class="modal-header bg-dark">
<h4 class="modal-title text-white">All Reminders</h4>
<button type="button" class="btn-close custom-btn-close bg-transparent fs-16 text-white position-static" data-bs-dismiss="modal" aria-label="Close"><i class="ti ti-x"></i></button>
</div>
<div class="modal-body">

   <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
    
    <div class="me-3" v-if="status !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  
    
    <div class="me-3">
     <select class="form-select" v-model="status">
      <option value="">Status</option>
      <option value="all">All</option>
      <option value="due">Due</option>
      <option value="pending">Pending</option>
      <option value="upcoming">Upcoming</option>
      <option value="completed">Completed</option>
     </select>
    </div>

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="all()"><i class="ti ti-search"></i></button>
    </div>

    </div> 
    
 <hr>   
 
 <div class="custom-datatable-filter table-responsive">
  <table class="table datatable thead-light" v-if="reminders?.length">
  <thead>
    <tr>
      <th>#</th>
      <th>Title</th>
      <th>Type</th>
      <th>Client</th>
      <th>Date-Time</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(row, index) in reminders" :key="row.id">
      <td>{{ serialNo + index + 1 }}.</td>
      <td><a data-bs-toggle="modal" data-bs-target="#reminder_view_modal" @click="editReminder(row)">{{ row.title }}</a></td>
      <td>{{ row.reminder_type }}</td>
      <td><a :href="`/crm/leads-details/${row.lead_id}`" target="_blank">{{ row?.lead?.name }}</a></td>
      <td>{{ $formatDate(row?.reminder_datetime, 'DD-MM-YYYY @ hh:mm A') }}</td>          
    </tr>
  </tbody>
  </table>
  
  <div v-else class="p-3 text-center text-muted"> No records found. </div>

  <!-- Pagination -->
  <nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
    <ul class="pagination pagination-sm">
      <li v-for="(link, index) in pagination.links" :key="index"
        :class="['page-item', { active: link.active, disabled: !link.url }]">
        <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
      </li>
    </ul>
  </nav>
  
</div> 

</div>
</div>
</div>
</div>
<!-- /All Reminders -->

<!-- Delete Modal -->
<div class="modal fade" id="reminder_delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
<span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
<i class="ti ti-trash-x fs-36"></i>
</span>
<h4 class="mb-1">Confirm Delete</h4>
<p class="mb-3">
You want to delete all the marked items, this cant be undone once you delete.
</p>
<div class="d-flex justify-content-center">
<a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
<a href="javascript:void(0);" class="btn btn-danger" @click="deleteReminder">Yes, Delete</a>
</div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->
</template>
